export const resume = {
	title: "Resumen",
	pageTitle: "Resumen de la promoción",
	description:
		"Verifique si toda la información está correcta y después publique la promoción. Será activada automáticamente y ya estará lista para uso.",
	sections: {
		allProducts: "Todos los productos",
		andMore: "y más {{count}} productos",
		promotionInfo: {
			title: "Información de la promoción",
			channel: "Canal",
			audience: "Quién podrá recibir la promoción",
			audienceValues: {
				everybody: "Todos los clientes",
				identifiedCpf: "Clientes identificados",
			},
			cpfPermissionWarning:
				"Para identificar a los clientes en el tótem ficha es necesario que el permiso 'captar CPF en el tótem ficha' esté activado.",
			name: "Nombre",
			description: "Descripción",
			maxUses: {
				label: "Cantidades de usos por ganancia",
				uses: "{{uses}} usos",
				withoutLimits: "Sin límites",
			},
			places: "Locales",
		},
		goals: {
			title: "Metas",
			frequency: "Recurrencia de ganancias",
		},
		awards: {
			title: "Premios",
			discount: "Porcentaje del descuento aplicado al producto",
			products: "Productos del descuento",
		},
		usageLimit: {
			label: "Límite de uso",
			uses: "{{uses}} usos",
		},
		usageConditions: "Condiciones del uso",
	},
};
